module.exports = __webpack_public_path__ + "img/image14.4d98a59a.webp";